module.exports = __webpack_public_path__ + "img/unelmakone-karta-en.77410d75.jpg";